import { QueryParam } from "../../../types/api/generic.type";
import {
  GetPotentialMatrixDevelopmentResponse,
  GetDevelopmentChartStatsResponse,
} from "../../../types/api/potentialMatrix.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const PotentialMatrixDevelopmentService = {
  async get(
    queryParams: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetPotentialMatrixDevelopmentResponse> {
    const params = queryParams ? createQueryParamString(queryParams, true) : "";
    const response =
      await httpClient.get<GetPotentialMatrixDevelopmentResponse>(
        `v1/potential-matrix-development${params}`,
        { signal },
      );
    return response;
  },
  async getChartStats(
    queryParams: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetDevelopmentChartStatsResponse> {
    const params = queryParams ? createQueryParamString(queryParams, true) : "";
    const response = await httpClient.get<GetDevelopmentChartStatsResponse>(
      `v1/potential-matrix-development/stats${params}`,
      { signal },
    );
    return response;
  },
};

export default PotentialMatrixDevelopmentService;
